import { FAVORITE_TYPE } from "enums/favorite-type";
import { DetailsExpire, festival } from "@types";

export interface UiCart {
  variant: CARD_VARIANT;
  favoriteIcon?: boolean;
  showTag?: boolean;
  showTeacher?: boolean;
  showTime?: boolean;
  showCloseIcon?: boolean;
  showRadioButton?: boolean;
  showPrice?: boolean;
  showDiscount?: boolean;
  hugElement?: boolean;
  noBorder?: boolean;
  showShoppingCart?: boolean;
  showDetail?: boolean;
  isFestival?: boolean;
  showFolderIcon?: boolean;
  folderStatus?: FOLDER_STATUS;
}

export interface ICardBase {
  id: number;
  isFavorite: boolean;
  png_image: string;
  svg_image: string;
  webp_image?: string;
  title: string;
  title_short?: string;
  slug: string;
  type: COURSE_TYPE;
  imageWidth?: number;
  tag?: CARD_TAG;
  changeFavorite?: () => void;
  handleFolderAction?: () => void;
  favoriteType?: FAVORITE_TYPE;
  svg_featured_image: string;
  png_featured_image: string;
  webp_featured_image?: string;
}

export interface ILandingCard extends ICardBase, UiCart {
  courseCount?: number;
  studentCount?: number;
  hugElement?: boolean;
  href: string;
  discount?: number;
}

export interface ICard extends ICardBase, UiCart {
  sku?: string;
  duration?: {
    hours: number;
    minutes: number;
    rounded_in_hour: number;
    in_minutes: number;
  };
  instructor?: IInstructor[];
  price?: number;
  isBuy: boolean;
  watchPercent: number;
  status?: STATUS;
  festival?: festival;
  festival_new?: festival;
  instructorCount?: number;
  // eslint-disable-next-line no-unused-vars
  submitRate?: (id: number) => void;
  inCart: boolean;
  sliderSlug?: string;
  imageWidth?: number;
  hasCertificate?: boolean;
  totalOrders?: number;
  details_expire?: DetailsExpire;
  linkTarget?: "_blank" | "_self";
  showSubscriptionBadge?: boolean;
  renderSubscriptionFooter?: boolean;
  notFullyClickable?: boolean;
}

export enum FOLDER_STATUS {
  MANAGE_FOLDER = "manage_folder",
  FOLDER_SELECT = "folder_select",
  FOLDER_REMOVE = "folder_remove",
}

export interface IInstructor {
  amount_fixed?: string;
  degree: DEGREE | null;
  last_name: string;
  contract_type_id?: number;
  profile_picture?: string | null;
  biography?: string;
  show_special_description?: number;
  special_description?: null | string;
  special_field?: null | string;
  instructor_caption: string;
  field?: string | null;
  user_id?: number;
  amount_percent?: string;
  biography_excerpt?: string;
  id?: number;
  first_name: string;
  slug?: string;
}

/* eslint-disable no-unused-vars */
export enum DEGREE {
  MSS = "mss",
  MS = "ms",
  PHD = "phd",
  PHD_S = "phds",
  BS = "bs",
  BSS = "bss",
}
export enum COURSE_TYPE {
  COURSE = "course",
  WEBINAR = "webinar",
  BLIND = "blind",
  PODCAST = "podcast",
  AUDIOBOOK = "audiobook",
  PACK = "pack",
  EXAM = "exam",
  SERVICES = "service",
  PACKAGE = "package",
  NOTE = "note",
  PRACTICE = "practice",
  PHYSICAL = "physical",
  TEXT = "text",
  BOOK = "book",
  VIDEO = "video",
}

export enum CARD_TAG {
  COURSE = "course",
  VIDEO = "video",
  BLIND = "blind",
  PODCAST = "podcast",
  AUDIOBOOK = "audiobook",
  PACK = "pack",
  EXAM = "exam",
  TEXT = "text",
  CERTIFICATE = "certificate",
}
export enum STATUS {
  PUBLISHING = "publishing",
  EDITING = "editing",
  RECORDING = "recording",
  START_RECORDING = "start_recording",
  PLANNING = "planning",
  UNPUBLISHED = "unPublished",
  PUBLISHED = "published",
  QUALITY_INSPECTION = "quality_inspection",
}

export enum CARD_VARIANT {
  GRID = "grid",
  LIST = "list",
  HALF_LIST = "half_list",
  CHECKBOX = "checkbox",
  START_LEARNING = "start_learning",
}

export enum CURRENT_STATUS {
  BOUGHT = "bought",
  NOT_PUBLISH = "not-publish",
  FREE = "free",
  SUBSCRIPTION = "subscription",
  DEFAULT = "default",
}
